import { ImageUser } from "@untitledui/icons"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { useInitials } from "@/hooks/use-initials"
import type { User } from "@/types"

export function UserInfo({
  user,
  showEmail = false,
  iconFallback = false,
}: {
  user: User
  showEmail?: boolean
  iconFallback?: boolean
}) {
  const getInitials = useInitials()

  return (
    <>
      <Avatar className="h-8 w-8 overflow-hidden rounded-full">
        {!iconFallback && <AvatarImage src={user.avatar} alt={user.name} />}
        <AvatarFallback className="rounded-lg bg-neutral-200 text-black dark:bg-neutral-700 dark:text-white">
          {iconFallback ? (
            <ImageUser className="h-4 w-4" />
          ) : (
            getInitials(user.name)
          )}
        </AvatarFallback>
      </Avatar>
      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-medium">{user.name}</span>
        {showEmail && (
          <span className="text-muted-foreground truncate text-xs">
            {user.email}
          </span>
        )}
      </div>
    </>
  )
}
